export function getBounds(widget) {
  var x1 = Number(widget.xCoordinate) || 1;
  var y1 = Number(widget.yCoordinate) || 1;
  var width = Number(widget.width) || 1;
  var height = Number(widget.height) || 1;

  return {
    x1,
    y1,
    x2: x1 + width,
    y2: y1 + height,
    width,
    height
  };
}

export function isFullyInside(containerWidget, candidateWidget) {
  if (!containerWidget || !candidateWidget || containerWidget.id === candidateWidget.id) {
    return false;
  }

  var containerBounds = getBounds(containerWidget);
  var candidateBounds = getBounds(candidateWidget);

  return (
    candidateBounds.x1 >= containerBounds.x1 &&
    candidateBounds.y1 >= containerBounds.y1 &&
    candidateBounds.x2 <= containerBounds.x2 &&
    candidateBounds.y2 <= containerBounds.y2
  );
}

export function getGridDimensions(widgets) {
  var maxCols = 1;
  var maxRows = 1;

  (widgets || []).forEach(function (widget) {
    var bounds = getBounds(widget);
    maxCols = Math.max(maxCols, bounds.x2 - 1);
    maxRows = Math.max(maxRows, bounds.y2 - 1);
  });

  return {
    columns: maxCols,
    rows: maxRows
  };
}

export function getWidgetGridStyle(widget) {
  return {
    gridColumn: String(widget.xCoordinate) + ' / span ' + String(widget.width),
    gridRow: String(widget.yCoordinate) + ' / span ' + String(widget.height)
  };
}
